//
//
//
//
//
//
//


export default {
  name: 'PanelHomeGroup',
  props: ['page'],
}



// WEBPACK FOOTER //
// ./scripts/vue/PanelHomeGroup.vue